export default __webpack_public_path__ + "d48766de7e7635e319ba1312091bf224.webp";